<div class="kot-dialog">
  <div class="dialog-header">
    <div class="d-flex align-items-center gap-2">
      <h2 class="mb-0">KOT {{ data.order.orderNumber }}</h2>
    </div>
    <button [mat-dialog-close]="true" mat-icon-button class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="kot-content">
    <div class="row">
      <div class="col-12 col-lg-7 receipt-column">
        <div class="receipt-header">
          <span nz-icon nzType="file-text" nzTheme="outline" class="section-icon"></span>
          <span class="section-title">KOT Preview</span>
        </div>
        <div class="d-flex justify-content-center">
          <div id="print-section">
            <div>
              <div [ngStyle]="shouldApplyWidth ? {'width': '2.5in'} : {'width': '3in'}"
                style="background-color: white; padding-bottom: 30px" class="ruda-font">
                <div>
                  <div>
                    <p style="font-size: 24px; margin-bottom: 0">{{ data.order.orderNumber }}</p>
                  </div>

                  <div style="font-size: 14px;">
                    {{ currentDate | date: 'dd-MM-yyyy' }} | {{ currentDate | date: 'h:mm a' }}
                  </div>

                  <div style="width: 100%; border-bottom: 2px solid"></div>

                  <div style="font-size: 14px;">
                    <div><b>ORDER T.</b>: <b
                  style="font-weight: 700">{{ orderTypes[data.order.orderType] | capitalize }}</b></div>
                  <div>
                    <b>SECTION</b>: <b style="font-weight: 700">{{ data.order.sectionName }}</b><br/>
                    <b>TABLE</b>: <b
                  style="font-weight: 700">{{ tableName(data.order.tables) | truncate: 15 }}</b>
                </div>
                <div>
                  <!--                    <b>CR.USER</b>: <b-->
                <!--                    style="font-weight: 700">{{ data.orderDetails.createdBy | userRole: allUsers : true | capitalize }}</b><br/>-->
                <b>ITEMS</b>: <b style="font-weight: 700">{{ data.order.cartResponseDetails.length }}</b>
              </div>
            </div>

            <div style="width: 100%; border-bottom: 2px solid"></div>

            <table>
              <tr style="font-weight: bold; font-size: 10px;">
                <td style="text-align: left;">ITEM</td>
                <td style="text-align: center;">SIZE</td>
                <td style="text-align: right;">QTY</td>
              </tr>

              @for (item of foods; track item.foodId; let i = $index) {
                <ng-container>
                  @if (item.selected) {
                    <tr style="font-size: 15px;">
                      <td style="text-align: left; word-wrap: break-word; width:50mm;">
                        <small><b>{{ item.foodId | foodItemName : data.foodItems }}</b></small>
                      </td>
                      <td style="text-align: center; width:20mm;">
                        <small><b>{{ item.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</b></small>
                      </td>
                      <td style="text-align: right;">
                        <small><b>{{ item.quantity }}</b></small>
                      </td>
                    </tr>

                    @if (item.extras?.length) {
                      <tr style="font-size: 15px;">
                        <td colspan="3">
                          <small style="font-size: 12px;"><b>Additional Items:</b></small>
                          @for (extra of item.extras; track extra) {
                            <br/>
                            <!--                          <small style="text-align: left; word-wrap: break-word;"><b>{{ extra.name }}</b></small>-->
                          }
                        </td>
                      </tr>
                    }

                    @if (item.kitchenIntroduction) {
                      <tr style="font-size: 15px;">
                        <td colspan="3">
                          <small style="font-size: 12px;"><b>Kitchen Intro:</b></small>
                          <br/>
                          <small
                            style="text-align: left; word-wrap: break-word;"><b>{{ item.kitchenIntroduction }}</b></small>
                          </td>
                        </tr>
                      }

                      <tr>
                        <td colspan="3">
                          <div style="width: 100%; border-bottom: 2px solid"></div>
                        </td>
                      </tr>
                    }
                  </ng-container>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="col-12 col-lg-5 items-column">
      <div class="section-header">
        <span nz-icon nzType="check-square" nzTheme="outline" class="section-icon"></span>
        <span class="section-title">Select Items</span>
      </div>
      @for (foodItem of foods; track foodItem.foodId) {
        <div class="d-flex">
          <label class="me-3" nz-checkbox [(ngModel)]="foodItem.selected"></label>
          <p class="my-auto">
            {{ foodItem.foodId | foodItemName : data.foodItems }}
          </p>
        </div>
      }
    </div>
  </div>
</div>

<div mat-dialog-actions class="dialog-footer">
  <button type="button" class="print-kot-btn"
    ngxPrint printSectionId="print-section" [useExistingCss]="true">
    <mat-icon>print</mat-icon>
    Print Kot
  </button>
</div>
</div>
